import React from 'react';
import ChatBubblesIcon from 'components/icons/chatbubbles';
import { Reference, ReferenceLink } from 'helpers/reference';
import Button from 'components/revelo-ui/content/button';
import { LinkItem } from 'components/commercetools-ui/account/details';
import { useFormat } from '../../../../../helpers/hooks/useFormat';

export interface ServiceAreaProps {
  enableBtn?: boolean;
  buttonText?: string;
  buttonLink?: Reference;
  linkList?: LinkItem[];
}
const ServiceArea: React.FC<ServiceAreaProps> = ({ enableBtn, buttonText, buttonLink, linkList }) => {
  const { formatMessage: formatAccountMessage } = useFormat({ name: 'account' });

  return (
    <div className="py-4">
      <div className="mb-4 flex items-center gap-4 text-lg">
        <ChatBubblesIcon className="size-6" />
        <span className="font-headline">
          {formatAccountMessage({ id: 'help.service', defaultMessage: 'Hilfe & Kontakt' })}
        </span>
      </div>
      <div className="text-md">
        <ul>
          {linkList.map(({ linkText, link }, index) => {
            const key = link.type === 'link' ? link.link : link.pageFolder.pageFolderId;

            return (
              <li className="mb-2" key={key || index}>
                <ReferenceLink
                  target={link}
                  className="border-b border-secondary-600 text-secondary-600 hover:opacity-90"
                >
                  {linkText}
                </ReferenceLink>
              </li>
            );
          })}
        </ul>
      </div>
      {enableBtn && (
        <div className="mt-6">
          <Button style="hollow" reference={buttonLink}>
            {buttonText}
          </Button>
        </div>
      )}
    </div>
  );
};

export default ServiceArea;
